<template>
  <v-card class="dialog" v-if="isSetParent">
    <v-card-title class="primary pa-0">
      <v-toolbar flat class="primary blue-grey--text text--darken-4 subtitle-1">
        <v-toolbar-title :class="{ caption: $vuetify.breakpoint.smAndDown, 'subtitle-1': $vuetify.breakpoint.mdAndUp }">{{ printTitle }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div v-if="isReady">
          <span :class="[ 'mr-4', { caption: $vuetify.breakpoint.smAndDown } ]">{{ `合計：${printTotal}` }}</span>
          <span :class="[ 'mr-4', { caption: $vuetify.breakpoint.smAndDown } ]">{{ `振分：${printDone}` }}</span>
          <span :class="[ 'mr-4', { caption: $vuetify.breakpoint.smAndDown } ]">{{ `残額：${printProcess}` }}</span>
        </div>
        <div v-else>
          <v-progress-circular indeterminate color="grey-blue darken-4" class="mr-2" size="20" width="2" />
          <span>読み込み中です...</span>
        </div>
        <template v-slot:extension v-if="config.step === 'detail'">
          <v-row dense>
            <v-col cols="12">
              <v-list-item dense>
                <v-list-item-content class="pt-4">
                  <v-autocomplete
                    ref="searcher"
                    v-model="form.sub.cid"
                    color="blue-grey darken-4"
                    label="振分する顧客を検索する"
                    prepend-icon="fa-user"
                    :items="getClientItems"
                    :loading="isSearching"
                    :search-input.sync="form.sub.search"
                    @keypress.enter.prevent="searchClient()"
                    @change="initForm()"
                  />
                </v-list-item-content>
                <v-list-item-action class="pb-2">
                  <v-btn depressed
                    v-if="form.sub.client.id"
                    color="blue-grey darken-4 primary--text"
                    @click="open({ type: 'accountant' })"><v-icon small class="mr-2">fal fa-file-plus</v-icon>会計を追加する</v-btn>
                  <v-btn depressed
                    v-else-if="getClient.id"
                    color="blue-grey darken-4 primary--text"
                    @click="initForm(getClient)">
                    <v-icon small class="mr-2">fal fa-plus</v-icon>
                    <span>{{ `${getClient.name.replace(',', ' ')}で追加する` }}</span>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-col>
          </v-row>
        </template>
      </v-toolbar>
    </v-card-title>
    <v-card-text>
      <v-container grid-list-md v-if="isSetParent && isReady">
        <v-window v-model="config.step">
          <v-window-item :value="'list'">
            <v-list dense v-if="getFormItems.length">
              <template v-for="item in getFormItems">
                <v-list-item
                  :key="item.id"
                  class="it-hv"
                  :disabled="item.flag === 'T'"
                  @click="open({ id: item.id, type: 'detail' })">
                  <v-list-item-avatar>
                    <v-icon small>fal fa-user</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-subtitle class="overline">
                      <span>{{ item.client }}</span>
                      <span v-if="item.flag === 'T'" class="red--text">【確】</span>
                      <span>{{ `：${item.cbook}`}}</span>
                    </v-list-item-subtitle>
                    <v-list-item-title class="title mb-1 blue-grey--text text--darken-4">{{ item.sum }}</v-list-item-title>
                    <v-list-item-subtitle class="overline">{{ `${item.labelJp}` }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn icon
                      :disabled="item.flag === 'T'"
                      @click.stop="remove(item)">
                      <v-icon small color="red">fal fa-trash-alt</v-icon>
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
                <v-divider :key="`${item.id}_div`"></v-divider>
              </template>
            </v-list>
            <v-list dense v-else>
              <v-list-item>
                <v-list-item-content>登録された振分がありません</v-list-item-content>
              </v-list-item>
            </v-list>
          </v-window-item>
          <v-window-item :value="'detail'">
            <v-form lazy-validation
              ref="detailForm"
              v-model="form.valids.detail"
              @submit.prevent="onSubmit">
              <v-row dense v-if="form.sub.client.id">
                <v-col cols="12">
                  <v-list-item class="pr-0">
                    <v-list-item-content>
                      <v-list-item-subtitle>{{ printTargetClientType }}</v-list-item-subtitle>
                      <v-list-item-title>
                        <span>{{ printTargetClientName }}</span>
                        <v-menu offset-y open-on-hover
                          v-if="getFormItems.length">
                          <template v-slot:activator="{ on }">
                            <v-btn text v-on="on" color="secondary">{{ `振分済み：${getFormItems.length}件` }}</v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item v-for="item in getFormItems"
                              :key="item.id"
                              class="it-hv"
                              @click="open({ id: item.id, type: 'detail' })">
                              <v-list-item-avatar>
                                <v-icon small>fal fa-user</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-subtitle class="caption">{{ `${item.client}：${item.cbook}/${meta.items[item.label] || item.label}` }}</v-list-item-subtitle>
                                <v-list-item-title>{{ item.sum }}</v-list-item-title>
                              </v-list-item-content>
                              <v-list-item-action>
                                <v-btn icon @click.stop="remove(item)">
                                  <v-icon small color="red">fal fa-trash-alt</v-icon>
                                </v-btn>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="form.sub.cbook.id"
                    label="振分先の会計"
                    prepend-icon="fal fa-file-contract"
                    :items="getCbookItems"
                    :rules="rules.required"
                  />
                </v-col>
                <v-col cols="6">
                  <v-select
                    v-model="form.sub.label"
                    label="勘定項目"
                    prepend-icon="fal fa-tag"
                    :items="getCbookItemItems"
                    :rules="rules.required"
                  />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="form.sub.sum"
                    class="text-right"
                    label="金額"
                    suffix="円"
                    append-outer-icon="fa-reply-all"
                    :rules="rules.number.required"
                    @click:append-outer="putAllSum"
                    @blur="verifySum(true)"
                    @focus="verifySum(false)"
                  />
                </v-col>
              </v-row>
            </v-form>
          </v-window-item>
        </v-window>
      </v-container>
      <v-container grid-list-md v-else>
        <v-progress-linear indeterminate color="secondary" />
      </v-container>
    </v-card-text>
    <v-divider></v-divider>
    <l-actions
      :fid="form.sub.id"
      :cid="form.sub.client.id"
      :type="config.step"
      :valid="form.valids[config.step]"
      :submittable="isValid"
      :status="config.status"
      @open="open"
      @close="close"
      @submit="assign"
      @emit="emitted"
    />
    <AccountantInserter
      ref="accountantInserter"
      :cid="form.sub.client.id"
      @done="insertAccountant"
    />
  </v-card>
  <div v-else>ERROR</div>
</template>

<script>
import _ from 'lodash'
import LActions from './actions'
import AccountantInserter from '@/pages/client/pages/accountant/modals/insert'
const DEF = {
  STEP: 'list'
}
export default {
  name: 'authorAccountantEditorLayoutClients',
  props: [ 'parent', 'client' ],
  components: {
    LActions,
    AccountantInserter
  },
  data () {
    return {
      config: {
        status: {
          ready: false,
          loading: false,
          searching: false
        },
        step: DEF.STEP
      },
      masks: {
        sum: {
          thousands: ',',
          precision: 0
        }
      },
      meta: {
        types: {
          deposites: '入金',
          payments: '支払',
          commissions: 'コミッション入金',
          dcpayments: 'カード支払',
          prefunds: '返金（引出し）',
          drefunds: '返金（預入れ',
          dcrefunds: 'カード返金'
        },
        items: {
          deposites: {
            client: {
              deposite: '入金',
              commission: '入金（コミッション）',
              bank_handling: '銀行手数料'
            },
            company: {
              'deposite': '入金',
              'commission': '入金（コミッション）',
              'school refund': '学費（返金）',
              'stay refund': '滞在費用（返金）',
              'aviation refund': '航空券代金（返金）',
              'insurance refund': '保険料（返金）',
              'visa refund': '査証費用（返金）',
              'support refund': 'サポート費用（返金）',
              'domestic refund': '国内諸経費（返金）',
              'others refund': 'その他（返金）',
              'other_private refund': 'その他（個人費用）（返金）',
              'other_hs refund': 'その他（高校留学）（返金）',
              'bank_handling': '銀行手数料'
            }
          },
          payments: {
            default: {
              'school': '学費', // NO TAX
              'stay': '滞在費用・海外送金', // NO TAX
              'aviation': '航空券代金',
              'insurance': '保険料',
              'visa': '査証費用',
              'support': 'サポート費用',
              'domestic': '国内諸経費',
              'others': 'その他',
              'other_private': 'その他（個人費用）', // NO TAX
              'other_hs': 'その他（高校留学）', // NO TAX
              'bank_handling': '銀行手数料',
              'school refund': '学費（返金）', // NO TAX
              'stay refund': '滞在費用（返金）', // NO TAX
              'aviation refund': '航空券代金（返金）',
              'insurance refund': '保険料（返金）',
              'visa refund': '査証費用（返金）',
              'support refund': 'サポート費用（返金）',
              'domestic refund': '国内諸経費（返金）',
              'others refund': 'その他（返金）',
              'other_private refund': 'その他（個人費用）（返金）', // NO TAX
              'other_hs refund': 'その他（高校留学）（返金）', // NO TAX
              'bank_handling refund': '銀行手数料（返金）',
              'commission': '学費（コミッション）' // NO TAX
            }
          },
          dcpayments: {
            default: {
              school: '学費', // NO TAX
              stay: '滞在費用・海外送金', // NO TAX
              aviation: '航空券代金',
              avicom: '航空券変更手数料',
              insurance: '保険料',
              visa: '査証費用',
              domestic: '国内諸経費',
              hotel: '現地ホテル・アパート代', // NO TAX
              apart: '国内ホテルアパート代',
              support: '現地サポート料', // NO TAX
              test: '現地テスト受験代', // NO TAX
              mobile: '現地携帯電話', // NO TAX
              computer: '現地パソコン代', // NO TAX
              examfee: '国内テスト受験料',
              textfee: '参考書代',
              hospital: '現地病院診察代金', // NO TAX
              tour: '現地ツアー代', // NO TAX
              traffic: '現地交通代', // NO TAX
              shipping: '現地荷物発送費', // NO TAX
              uniform: '現地制服教材費', // NO TAX
              carry: '繰越金',
              bank_handling: '現地銀行手数料' // NO TAX
            }
          },
          drefunds: {
            default: {
              school: '学費（返金）',
              stay: '滞在費用（返金）',
              aviation: '航空券代金（返金）',
              insurance: '保険料（返金）',
              visa: '査証費用（返金）',
              support: 'サポート費用（返金）',
              domestic: '国内諸経費（返金）',
              others: 'その他（返金）',
              other_private: 'その他（個人費用）（返金）',
              other_hs: 'その他（高校留学）（返金）',
              bank_handling: '銀行手数料',
            }
          },
          prefunds: {
            default: {
              school: '学費（返金）',
              stay: '滞在費用（返金）',
              aviation: '航空券代金（返金）',
              insurance: '保険料（返金）',
              visa: '査証費用（返金）',
              support: 'サポート費用（返金）',
              domestic: '国内諸経費（返金）',
              others: 'その他（返金）',
              other_private: 'その他（個人費用）（返金）',
              other_hs: 'その他（高校留学）（返金）',
              bank_handling: '銀行手数料',
            }
          },
          dcrefunds: {
            default: {
              school: '学費（返金）',
              stay: '滞在費用（返金）',
              aviation: '航空券代金（返金）',
              insurance: '保険料（返金）',
              visa: '査証費用（返金）',
              support: 'サポート費用（返金）',
              domestic: '国内諸経費（返金）',
              others: 'その他（返金）',
              other_private: 'その他（個人費用）（返金）',
              other_hs: 'その他（高校留学）（返金）',
              bank_handling: '銀行手数料',
            }
          },
          commissions: {
            default: {
              commission: '入金（コミッション）'
            }
          }
        }
      },
      store: {
        clients: [],
        cbooks: [],
        items: []
      },
      form: {
        valids: {
          list: true,
          detail: true
        },
        items: [],
        sub: {
          id: '',
          client: {},
          cid: '',
          search: '',
          label: '',
          sum: '',
          cbook: {
            id: '',
            type: '',
            title: ''
          }
        }
      },
      rules: {
        required: [
          v => !!v || '必須項目です'
        ],
        number: {
          required: [
            v => (v && v !== '0') || '必須項目です'
          ]
        }
      }
    }
  },
  methods: {
    onSubmit: function () { return false },
    init: function () {
      this.$set(this.config.status, 'ready', false)
      this.submit({ type: 'children' })
    },
    emitted: function (req) {
      const { action, data } = req || {}
      if (typeof this[action] === 'function') {
        this[action](data)
      }
    },
    preSubmit: function (req) {
      const { type } = req || {}
      const { sub, items } = this.form
      const { client, search } = sub
      const pid = this.$props.parent ? this.$props.parent.id : ''
      const roles = this.$store.getters['author/get']('roles')
      const urls = {
        children: `${this.$url.api}accountant/get/people/items/${pid}`,
        client: `${this.$url.api}client/get/items`,
        cbook: `${this.$url.api}cbook/get/items/${client.id}`,
        assign: `${this.$url.api}accountant/assign/items/${pid}`
      }
      const fds = {
        children: {},
        client: {
          name: search,
          isAdmin: roles.includes('admin')
        },
        cbook: {},
        assign: { items }
      }
      if (type && urls[type] && fds[type]) {
        if (type === 'children') {
          this.$set(this.config.status, 'loading', true)
          return { type, url: urls[type], fd: fds[type] }
        } else if (type === 'client' && search) {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else if (type === 'cbook') {
          this.$set(this.config.status, 'searching', true)
          return { type, url: urls[type], fd: fds[type] }
        } else if (type === 'assign') {
          this.$set(this.config.status, 'loading', true)
          return { type, url: urls[type], fd: fds[type]}
        } else if (this.$refs.form && this.$refs.form.validate()) {
          this.$set(this.config.status, 'loading', true)
          return { type, url: urls[type], fd: fds[type] }
        } else {
          return false
        }
      } else {
        return false
      }
    },
    submit: function (req) {
      const dt = this.preSubmit(req)
      if (dt) {
        const { type, url, fd } = dt
        this.$firebase.auth().currentUser.getIdToken(true).then(token => {
          this.axios.post(url, fd, {
            headers: {
              'firebase-token': token
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.postSubmit({
                type,
                data: res.data.data
              })
            } else {
              this.failSubmit()
            }
          }).catch(err => {
            console.log(err)
            this.failSubmit()
          })
        })
      }
    },
    postSubmit: function (req) {
      const { type, data } = req || {}
      if (type === 'children') {
        this.$set(this.config.status, 'loading', false)
        this.$set(this.form, 'items', data)
        this.$set(this.config.status, 'ready', true)
      } else if (type === 'client') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store, 'clients', data)
      } else if (type === 'cbook') {
        this.$set(this.config.status, 'searching', false)
        this.$set(this.store, 'cbooks', data)
      } else if (type === 'assign') {
        this.$set(this.config.status, 'loading', false)
        this.$emit('done', data)
        this.close()
      }
    },
    failSubmit: function () {
      this.$set(this.config.status, 'loading', false)
      this.$set(this.config.status, 'searching', false)
    },
    searchClient: _.debounce(function (val) {
      this.submit({ type: 'client' })
    }, 300),
    initForm: function (req) {
      const { cid } = this.form.sub || {}
      if (req && req.id) {
        this.$set(this.form.valids, 'detail', true)
        this.$set(this.form.sub, 'client', req)
        this.$set(this.form.sub, 'cid', '')
        this.$set(this.store, 'clients', [])
      } else if (cid) {
        let idx = this.store.clients.findIndex(it => { return it.id === cid })
        if (idx >= 0) {
          this.$set(this.form.valids, 'detail', true)
          this.$set(this.form.sub, 'client', this.store.clients[idx])
          this.$set(this.form.sub, 'cid', '')
          this.$set(this.store, 'clients', [])
        }
      }
      this.submit({ type: 'cbook' })
    },
    verifySum: function (isFormat) {
      const { sum } = this.form.sub
      if (isFormat) {
        this.$set(this.form.sub, 'sum', (sum && isFinite(sum)) ? `${parseInt(sum)}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,') : '')
      } else {
        this.$set(this.form.sub, 'sum', sum.replace(/,/g, ''))
      }
    },
    putAllSum: function () {
      const total = this.$props.parent.sum && isFinite(this.$props.parent.sum) ? parseInt(this.$props.parent.sum) : 0
      const done = this.form.items.length ? this.form.items.reduce((prev, current) => {
        return prev + (current.sum && isFinite(current.sum) ? parseInt(current.sum) : 0)
      }, 0) : 0
      if (total === done) {
        this.$store.dispatch('notifier/addAlert', {
          title: '入力失敗',
          message: '残高がありません。'
        })
      } else {
        this.$set(this.form.sub, 'sum', `${total - done}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'))
      }
    },
    assign: function () {
      this.submit({ type: 'assign' })
    },
    insert: function (req) {
      const { isSeries } = req || {}
      if (this.$refs.detailForm.validate()) {
        const { id, client, sum, label, cbook } = this.form.sub || { cbook: {} }
        const { title, flag } = this.store.cbooks[this.store.cbooks.findIndex(it => { return it.id === cbook.id })] || {}
        let idx = this.form.items.findIndex(it => { return it.id === id })
        if (idx >= 0) {
          this.form.items.splice(idx, 1, {
            id,
            cid: client.id,
            client,
            sum: sum.replace(/,/g, ''),
            label,
            cbook: {
              id: cbook.id || '',
              type: cbook.type || 'exist',
              title: cbook.title || title || '',
              flag
            }
          })
        } else {
          this.form.items.push({
            id: this.$uuid(),
            cid: client.id,
            client,
            sum: sum.replace(/,/g, ''),
            label,
            cbook: {
              id: cbook.id || '',
              type: cbook.type || 'exist',
              title: cbook.title || title || '',
              flag
            }
          })
        }
        if (isSeries) {
          this.open({ type: 'detail', client })
        } else {
          this.open({ type: 'list' })
        }
      }
    },
    insertAccountant: function (req) {
      this.store.cbooks.push(req)
    },
    remove: function (req) {
      const { id } = req
      let idx = this.form.items.findIndex(it => { return it.id === id })
      if (idx >= 0) {
        this.form.items.splice(idx, 1)
      }
    },
    open: function (req) {
      const { id, type } = req || {}
      if (type === 'detail') {
        let idx = this.form.items.findIndex(it => { return it.id === id })
        const { client, sum, label, cbook } = idx >= 0 ? this.form.items[idx] : { client: req.client, cbook: {} }
        this.$set(this.form, 'sub', {
          id: id || '',
          client: client || {},
          cid: '',
          search: '',
          sum: sum || '',
          label: label || '',
          cbook: {
            id: cbook.id || '',
            type: cbook.type || 'exist',
            title: cbook.title || '',
          }
        })
        this.$nextTick(() => {
          this.verifySum(true)
        })
        this.$set(this.config, 'step', type)
        if (client && client.id) {
          this.submit({ type: 'cbook' })
        } else {
          setTimeout(() => { this.$refs.searcher.focus() }, 500)
        }
      } else if (type === 'list') {
        this.$set(this.config, 'step', type)
      } else if (type === 'accountant') {
        this.$refs.accountantInserter.open()
      }
    },
    close: function () {
      this.$emit('close')
    }
  },
  watch: {
    'form.sub.search': function (newVal, oldVal) {
      if (newVal && oldVal && newVal.length < oldVal.length) {
        this.$set(this.store, 'clients', [])
      }
      if (!this.config.status.searching && !this.store.clients.length) {
        this.searchClient()
      }
    },
    'form.sub.sum': function (v) {
      this.form.sub.sum = v ? v.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) { return String.fromCharCode(s.charCodeAt(0) - 65248) }) : ''
    }
  },
  computed: {
    isReady () {
      return this.config.status.ready
    },
    isValid () {
      const total = this.$props.parent.sum && isFinite(this.$props.parent.sum) ? parseInt(this.$props.parent.sum) : 0
      const sum = this.form.items.length ? this.form.items.reduce((prev, current) => {
        return prev + (current.sum && isFinite(current.sum) ? parseInt(current.sum) : 0)
      }, 0) : 0
      return total >= sum
    },
    isLoading () {
      return this.config.status.loading
    },
    isSearching () {
      return this.config.status.searching
    },
    isSetParent () {
      return this.$props.parent
    },
    printTitle () {
      const { client, type } = this.$props.parent || {}
      return [
        this.meta.types[type] || type,
        client.name.replace(',', '')
      ].join('：')
    },
    printTotal () {
      return `¥${this.$props.parent.sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    printDone () {
      const sum = this.form.items.length ? this.form.items.reduce((prev, current) => {
        return prev + (current.sum && isFinite(current.sum) ? parseInt(current.sum) : 0)
      }, 0) : 0
      return `¥${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    printProcess () {
      const total = this.$props.parent.sum && isFinite(this.$props.parent.sum) ? parseInt(this.$props.parent.sum) : 0
      const done = this.form.items.length ? this.form.items.reduce((prev, current) => {
        return prev + (current.sum && isFinite(current.sum) ? parseInt(current.sum) : 0)
      }, 0) : 0
      return `¥${total - done}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    },
    printTargetClientName () {
      const { name, kana } = this.form.sub.client
      return `${name ? name.replace(',', ' ') : ''}（${kana ? kana.replace(',', ' ') : ''}）`
    },
    printTargetClientType () {
      const { type } = this.form.sub.client
      return type === 'client' ? '顧客' : (type === 'guardian' ? '保護者' : (type === 'company' ? '企業' : ''))
    },
    geetTargetClientItems () {
      const { id } = this.form.sub.client || {}
      return this.form.items.filter(it => { return it.cid === id }) || []
    },
    getStoreItems () {
      return this.store.items.length ? this.store.items : []
    },
    getFormItems () {
      const { type } = this.$props.parent || {}
      const parentType = this.$props.parent && this.$props.parent.type
      const clientType = this.$props.parent && this.$props.parent.client && this.$props.parent.client.type
      const metaItems = this.meta.items[parentType] ? (this.meta.items[parentType][clientType] || this.meta.items[parentType].default) : []
      return this.form.items.length ? this.form.items.map(it => {
        const { id, type, sum, client, label, cbook } = it
        const { title, flag } = cbook || {}
        return {
          id,
          cid: client.id || '',
          sum: `¥${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
          client: (client && client.name) ? client.name.replace(',', ' ') : '',
          label: label || '',
          labelJp: metaItems[label] || metaItems[type] || label || type || '',
          cbook: title || '',
          flag
        }
      }) : []
    },
    getClient () {
      return this.$props.client || {}
    },
    getClientItems () {
      return this.store.clients.length ? this.store.clients.map(it => {
        return {
          text: `${it.name.replace(',', '')}（${it.kana.replace(',', '')}）`,
          value: it.id
        }
      }) : []
    },
    getCbookItems () {
      return this.store.cbooks.length ? this.store.cbooks.filter(it => { return (it.flag && it.flag !== 'T') }).map(it => {
        return {
          text: it.title,
          value: it.id
        }
      }) : []
    },
    getCbookItemItems () {
      const parentType = this.$props.parent && this.$props.parent.type
      const clientType = this.$props.parent && this.$props.parent.client && this.$props.parent.client.type
      const items = this.meta.items[parentType] && (this.meta.items[parentType][clientType] || this.meta.items[parentType].default)
      return items ? Object.keys(items).map(key => {
        return {
          text: items[key],
          value: key
        }
      }) : []
    },
    getSumItems () {
      const total = this.$props.parent.sum && isFinite(this.$props.parent.sum) ? parseInt(this.$props.parent.sum) : 0
      const done = this.form.items.length ? this.form.items.reduce((prev, current) => {
        return prev + (current.sum && isFinite(current.sum) ? parseInt(current.sum) : 0)
      }, 0) : 0
      return [ `${total - done}` ]
    }
  }
}
</script>